<template>
  <div class="pieEchartPage" ref="pieEchartPage">
      <div :id="pieData.id"></div>
  </div>
</template>

<script>
import * as echarts from "echarts";
export default {
  name: "pieEcharts",
   props: {
    pieData: {
      type: Object,
      default: () => ({}),
    },
  },
  data(){
    return{
        dom: null,
    }
  },
  mounted(){
    this.$nextTick(() => {
      if (this.pieData.id && this.pieData.chartOption) {
        document.getElementById(this.pieData.id).style.width =
          this.$refs.pieEchartPage.offsetWidth + "px";
        document.getElementById(this.pieData.id).style.height =
          this.$refs.pieEchartPage.offsetHeight + "px";
        this.drawPie();
      }
    });
  },
  methods:{
      drawPie() {
      let _this = this;
      const option = _this.pieData.chartOption;
      let myChart = document.getElementById(_this.pieData.id);
      this.dom = echarts.init(myChart);
      this.dom.setOption(option, true);
       window.addEventListener("resize", () => {
        if (document.getElementById(_this.pieData.id) && this.$refs. pieEchartPage) {
          document
            .getElementById(_this.pieData.id)
            .removeAttribute("_echarts_instance_");
          document.getElementById(_this.pieData.id).style.width =
            this.$refs.pieEchartPage.offsetWidth + "px";
          document.getElementById(_this.pieData.id).style.height =
            this.$refs.pieEchartPage.offsetHeight + "px";
          this.dom.resize();
        }
      });
    },
  },
   watch: {
    pieData: {
      handler(newData) {
        if (newData.id && newData.chartOption) {
          document.getElementById(newData.id).style.width =
            this.$refs.pieEchartPage.offsetWidth + "px";
          document.getElementById(newData.id).style.height =
            this.$refs.pieEchartPage.offsetHeight + "px";
          this.drawPie();
        }
      },
      deep: true,
    },
  },
};
</script>


<style lang="less" scoped>
.pieEchartPage {
  width: 100%;
  height: 100%; /*填满父级容器*/
}
</style> 